"use strict";

/**
 * @generated SignedSource<<75086f58e7135bd500931985a769c8f5>>
 * @relayHash b86f9b28a3dbe85be6dec1e6a7a3066c
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9ab056dd91d78eb2158abbc2bb8a9de409dd1bd7837e492adecc480568e4e290

const node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "slug"
    }],
    v1 = [{
      "kind": "Variable",
      "name": "slug",
      "variableName": "slug"
    }],
    v2 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    v3 = {
      "kind": "InlineFragment",
      "selections": [v2 /*: any*/, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dbId",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }],
      "type": "Supplier",
      "abstractKey": null
    };
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "metadata": null,
      "name": "useSelectedGlobalSupplierFetchQuery",
      "selections": [{
        "alias": null,
        "args": v1 /*: any*/,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "supplier",
        "plural": false,
        "selections": [v3 /*: any*/],
        "storageKey": null
      }],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "useSelectedGlobalSupplierFetchQuery",
      "selections": [{
        "alias": null,
        "args": v1 /*: any*/,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "supplier",
        "plural": false,
        "selections": [{
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }, v3 /*: any*/, {
          "kind": "InlineFragment",
          "selections": [v2 /*: any*/],
          "type": "Node",
          "abstractKey": "__isNode"
        }],
        "storageKey": null
      }]
    },
    "params": {
      "id": "9ab056dd91d78eb2158abbc2bb8a9de409dd1bd7837e492adecc480568e4e290",
      "metadata": {},
      "name": "useSelectedGlobalSupplierFetchQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "d8f82fa238abcb6dfa84642bce9ca5a7";
export default node;